module.exports = __webpack_public_path__ + "media/slot-game/beer-c2ffc9f0.svg";